import type { Step } from '@/components/wizard/Step';

import type { AzureOnboardingState } from './azureOnboardingState';
import { ConnectAzureSourceAccount } from './connectAzureSourceAccount';
import { ConnectAzureTenant } from './connectAzureTenant';

export const azureOnboardingFlow: Step<AzureOnboardingState> = {
  id: 'management_access',
  Component: ConnectAzureTenant,
  nonReturnable: false,
  next: [
    {
      id: 'source_connection',
      Component: ConnectAzureSourceAccount,
    },
  ],
};
